import styled from 'styled-components'

const ItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

export { ItemsContainer }
